export default {
  tradeAndEarn: {
    title: 'Trade & Earn',
    description:
      'Earn INJ by trading on the Spot and Perpetual trading pages or using a trading bot',

    pts: 'pts',
    stakeMore: 'Stake more',
    makerPoints: 'maker pts',
    takerPoints: 'taker pts',
    estRewards: 'Est. Rewards',
    campaignAsOf: 'As of {date}',
    estRewardsStake: 'Est. Rewards',
    pendingRewards: 'Pending Rewards',
    emptyPendingRewards: 'No pending rewards available.',
    pendingMaxCampaignRewards: 'Total allocated Rewards',
    myRewardPoints: 'My Reward Points / Total Reward Points',
    stakeTotalToReceiveFullAmount:
      'Stake total of {total} INJ to receive the full amount',
    sunset:
      'Thank you for participating in Trade & Earn! Stay tuned for upcoming programs designed to reward Helix users.',
    pendingMaxCampaignRewardsTooltip:
      'The total number of INJ that was distributed in the previous epoch. Reward distribution will happen at the end of the vesting period.',
    myRewardPointsTooltip:
      'The current reward points you earned during this campaign and the total reward points in the campaign. Reward points will reset to 0 at the beginning of next campaign.',
    estRewardsStakeTooltip:
      'Estimated reward to be distributed to this address based on your reward points /  total reward points * total allocated rewards. This is calculated assuming that your reward points grow just as fast as total reward points until the end of the campaign.  In order to maintain or maximize your reward, you should maintain the same or higher trading activity until the end of the campaign. Rewards amount is capped at {maxRewards} INJ or the equivalent amount of INJ staked, whichever is higher'
  }
}
